import { Constants } from 'constants';

import React from 'react';
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  isWhiteListUser,
} from 'utils';

import Gaplite from 'components/pages/gaplite';
import ErrorPage from 'components/pages/errorpage';
import Cyber from 'components/pages/cyber';
import PPTX from 'components/pages/pptx';

function Layout({
  data,
  actisKey,
  actisDataObj,
  isCyber,
  // initializeFullStory,
}) {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate(isCyber
      ? Constants.URLs.CYBER
      : Constants.URLs.DES);
  };

  return (
    <Routes>
      {(isWhiteListUser(data?.role, Constants.ROLES.DES)) && (
        <>
          <Route
            path={Constants.URLs.DES}
            element={<Gaplite actisDataObj={actisDataObj} />}
          />
          <Route
            path={Constants.URLs.RAPID}
            element={<Navigate replace to={`/${Constants.URLs.DES}`} />}
          />
          <Route
            path={Constants.URLs.ANY_URL}
            element={(
              <ErrorPage
                actisDataObj={actisDataObj}
                actisKey={actisKey}
                title={Constants.PAGE_NOT_FOUND_ERROR.TITLE}
                body1={Constants.PAGE_NOT_FOUND_ERROR.BODY1}
                body2={Constants.PAGE_NOT_FOUND_ERROR.BODY2}
                label={Constants.PAGE_NOT_FOUND_ERROR.LABEL}
                handleClick={goToDashboard}
              />
        )}
          />
        </>
      )}
      {(isWhiteListUser(data?.role, Constants.ROLES.CYBER)) && (
        <>
          <Route
            path={Constants.URLs.CYBER}
            element={<Cyber actisDataObj={actisDataObj} userData={data} />}
          />
          <Route
            path={Constants.URLs.CYBER_PPTX_DOWNLOAD}
            element={<PPTX />}
          />
          <Route
            path={Constants.URLs.CYBER_OLD}
            element={<Navigate replace to={`/${Constants.URLs.CYBER}`} />}
          />
          <Route
            path={Constants.URLs.ANY_URL}
            element={(
              <ErrorPage
                actisDataObj={actisDataObj}
                actisKey={actisKey}
                title={Constants.PAGE_NOT_FOUND_ERROR.TITLE}
                body1={Constants.PAGE_NOT_FOUND_ERROR.BODY1}
                body2={Constants.PAGE_NOT_FOUND_ERROR.BODY2}
                label={Constants.PAGE_NOT_FOUND_ERROR.LABEL}
                handleClick={goToDashboard}
              />
            )}
          />
        </>
      )}
      {/* // Keeping this code for future need */}
      {/* <Route
        path={Constants.URLs.INVITATION}
        element={(
          <Gaplite
            actisDataObj={actisDataObj}
            isInvitationRoute
            initializeFullStory={initializeFullStory}
          />
        )}
      /> */}
      <Route
        path={Constants.URLs.ANY_URL}
        element={(
          <ErrorPage actisKey={actisKey} actisDataObj={actisDataObj} />
        )}
      />
    </Routes>
  );
}

Layout.propTypes = {
  data: PropTypes.instanceOf(Object),
  actisKey: PropTypes.string,
  actisDataObj: PropTypes.instanceOf(Object),
  isCyber: PropTypes.bool,
  // initializeFullStory: PropTypes.func,
};

Layout.defaultProps = {
  data: {},
  actisKey: '',
  actisDataObj: {},
  isCyber: false,
  // initializeFullStory: () => {},
};

export default Layout;
